module.exports = __webpack_public_path__ + "img/ico-company.fcbcfc52.svg";